<div class="surface-card p-4 shadow-1 border-round">
  <div class="grid">
    <div class="font-medium text-xl text-900 mb-3 col-12 md:col-11">
      {{ settings.head.title }}
    </div>
    <ng-container *ngIf="settings.head.actions">
      <div *ngFor="let action of settings.head.actions" class="mr-1">
        <button
          pButton
          pRipple
          [icon]="action.icon"
          [class]="action.class"
          (click)="onSendAction(action)"
          [pTooltip]="action.pTooltip"
          tooltipPosition="left"
        ></button>
      </div>
    </ng-container>
  </div>
  <ul class="list-none p-0 m-0">
    <li
      *ngFor="let row of settings.body.rows"
      class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap"
    >
      <div class="text-500 w-2 md:w-5 font-medium">
        {{ row.header }}
      </div>
      <div class="text-900 w-full ml-1 md:w-6 md:flex-order-0 flex-order-1">
        {{ row.value }}
      </div>
    </li>
  </ul>
</div>
